/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum VbrDeployType {
    Unknown,
    Install,
    Upgrade,
}
